export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-lightbulb-8b72fef669f52491335413ac57718864.svg";